import { Component, Input } from '@angular/core';
import {
  ChannelsForChannelListFragment,
  Device,
  Maybe,
  Playlist,
} from '@designage/gql';
import { DeviceDataService } from '@desquare/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlaylistManageDialogComponent } from '../playlist-manage-dialog/playlist-manage-dialog.component';
import { Router } from '@angular/router';

interface IDeviceCommandItem extends IButtonVisibility {
  label: string;
  iconClassName: string;
  callback: () => any;
}

interface IButtonVisibility {
  show?: boolean;
  disable?: boolean;
}

@Component({
  selector: 'app-device-connected-links',
  templateUrl: './device-connected-links.component.html',
  styleUrls: ['./device-connected-links.component.scss'],
})
export class DeviceConnectedLinksComponent {
  @Input('links') links!: {
    loading: boolean;
    playlists: Playlist[];
    channel: Maybe<ChannelsForChannelListFragment>;
  };
  @Input() deviceId?: Device;
  @Input() channelId!: string;
  @Input() connection!: 'channel' | 'playlists';

  constructor(
    private deviceDataService: DeviceDataService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  openPlaylistInModal(playlist: Playlist) {
    const modal = this.modalService.open(PlaylistManageDialogComponent, {
      backdrop: 'static',
      windowClass: 'cesdk-modal',
      keyboard: false,
    });

    modal.componentInstance.playlistId =
      playlist.parentPlaylist?.id || playlist.id;

    modal.result.then(
      () => {},
      () => {}
    );
  }

  navigateToChannel(channelId: string) {
    if (channelId) {
      this.deviceDataService.currentUserService.navigateToChannel(channelId);
    }
  }

  getRegion(playlistId: string) {
    return this.links.channel?.playlistRegions?.find(
      (x) => x.playlistId === playlistId
    )?.region;
  }

  navigateToPlaylist(id: string) {
    this.deviceDataService.currentUserService.navigateToPlaylist(id);
  }
  navigateToPlaylistList() {
    this.router.navigate(['/profile/playlists']);
  }
}
